import Button from "@modul-connect/shared/components/atoms/button/button.v2"
import { H5, H3, P } from "@modul-connect/shared/components/atoms/text"
import View from "@modul-connect/shared/components/atoms/view"
import theme from "@modul-connect/shared/theme"
import { useTranslation } from "react-i18next"

const styles = {
  column: {
    display: 'flex', 
    flexDirection: 'column',
    gap: 5
  },
  smallTitle: {
    paddingTop: 10
  }
}

export const VehicleTemplateDetails = ({ template, onDelete, setTemplateSelectModalOpen, setSelectedVehicleId, mainBoxId }) => {

  const {t} = useTranslation()
  return (
    <View style={{ padding: 20, backgroundColor: theme.colors.bg, cursor: 'default' }}>
      <View style={{ ...theme.shadowStyle, backgroundColor: theme.colors.bg, padding: 10, borderRadius: 8 }}>
        <View style={{ display: 'flex', flexDirection: 'column', backgroundColor: theme.colors.tableBackground2, paddingTop: 10, paddingBottom: 20, paddingLeft: 20, paddingRight: 20 }}>
          <H3 extend={{ paddingBottom: 5, margin: 0 }}>
            {t('climateSystem.settings.settings')}
          </H3>
              <View style={{ display: 'flex', flexDirection: 'row', gap: 100 }}>
                <View style={styles.column}>
                  <H3 noPadding extend={{ fontWeight: 'bold' }}>
                    {t('climateSystem.settings.template.temperatureLimits')}
                  </H3>
                  <H5 extend={styles.smallTitle}>
                  {t('climateSystem.settings.template.temperatureRange')}
                  </H5>
                  {template ? (
                    <P small noPadding>{`${template.lowerCriticalThreshold}–${template.upperCriticalThreshold}°C`}</P>
                  ): (
                    <P small noPadding extend={{fontStyle: 'italic', color: theme.colors.disabledText}}>Not set</P>
                  )}
                  <H5 extend={styles.smallTitle}>
                  {t('climateSystem.settings.template.preWarningsTemperatureRange')}
                  </H5>
                  {template ? (
                  <P small noPadding>{ `${template.lowerWarningThreshold}–${template.upperWarningThreshold}°C`}</P>
                  ): (
                    <P small noPadding extend={{fontStyle: 'italic', color: theme.colors.disabledText}}>Not set</P>
                  )}
                </View>
                <View style={styles.column}>
                  <H3 noPadding extend={{ fontWeight: 'bold' }}>
                    {t('climateSystem.settings.template.email')}

                  </H3>
                  <H5 extend={styles.smallTitle}>
                    {t('climateSystem.settings.template.receiver')}

                  </H5>
                  {template?.errorEmailAddresses?.length > 0 ? (
                    template.errorEmailAddresses.map((email) => (
                    <P key={email} small noPadding>{email}</P>
                  ))
                ) : (
                <P small noPadding extend={{fontStyle: 'italic', color: theme.colors.disabledText}}>Not set</P>
                )}
                  <H5 extend={styles.smallTitle}>
                    {t('climateSystem.settings.template.sendAlertAfter')}
                  </H5>
                  {template ? (
                  <P small noPadding>{template.errorTime}</P>
                  ): (
                    <P small noPadding extend={{fontStyle: 'italic', color: theme.colors.disabledText}}>Not set</P>
                  )}
                </View>
                <View style={styles.column}>
                  <H3 noPadding extend={{ fontWeight: 'bold' }}>
                    {t('climateSystem.settings.template.notificationAndReportSchedule')}
                  </H3>
                  <H5 extend={styles.smallTitle}>
                    {t('climateSystem.settings.template.startEndTime')}

                  </H5>
                  {template?.armedSchema?.startTimeLocal && template?.armedSchema?.endTimeLocal ? (
                    <P small noPadding>
                      {`${template.armedSchema.startTimeLocal.slice(0, 5)}–${template.armedSchema.endTimeLocal.slice(0, 5)}`}
                    </P>
                    ) : (
                    <P small noPadding extend={{fontStyle: 'italic', color: theme.colors.disabledText}}>Not set</P>
                  )}
                  <H5 extend={styles.smallTitle}>
                    {t('climateSystem.settings.template.affectedDays')}
                  </H5>
                  {template?.armedSchema?.daysOfWeek?.length > 0 ? (
                    template.armedSchema.daysOfWeek.map((day) => (
                    <P key={day} small noPadding>
                      {t(`climateSystem.settings.template.days.${day.toLowerCase()}`)}
                    </P>
                    ))
                  ) : (
                  <P small noPadding extend={{fontStyle: 'italic', color: theme.colors.disabledText}}>Not set</P>
                  )}
                </View>
              </View>
        </View>
      </View>
      {template ? (
      <View style={{marginTop: 8, display: 'flex', justifyContent: 'flex-end' }}>
        <Button 
        icon='Change' 
        color={'transparent'} 
        extend={{ 
          color: theme.colors.blue, 
          fontSize: '16px', 
          fontWeight: 500 
        }} 
        onClick={() => {
          setSelectedVehicleId(mainBoxId)
          setTemplateSelectModalOpen(true)
        }} 
        >
          {t('climateSystem.settings.template.changeTemplate')}
        </Button>
        <Button 
        icon='Delete' 
        color={'transparent'} 
        extend={{ 
          color: theme.colors.midDarkGrey, 
          fontSize: '16px', 
          fontWeight: 500 
        }} 
        onClick={onDelete} 
        >
          {t('climateSystem.settings.template.removeTemplate')}
        </Button>
      </View>
      ):(      
      <View style={{marginTop: 8, display: 'flex', justifyContent: 'flex-end' }}>
        <Button 
        icon='Change' 
        color={'transparent'} 
        extend={{ 
          color: theme.colors.blue, 
          fontSize: '16px', 
          fontWeight: 500 
        }} 
        onClick={() => {
          setSelectedVehicleId(mainBoxId)
          setTemplateSelectModalOpen(true)
        }} 
        >
          {t('climateSystem.settings.template.connectExistingTemplate')}
        </Button>
      </View>
      )}
    </View>

  )}